// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1PXfS","selects":"Documents_selects__2rQqO"};